import { getPanelOptions } from '../utils';
import RadioListComponent from '72cms-ui/components/form-elements/RadioListComponent';
import UrlSelectComponent from '72cms-ui/components/form-elements/UrlSelectComponent';

export default {
    sections: ['details'],
    toolbar: ['add', 'edit', 'active', 'delete'],
    fields: {
        type: {
            noTitle: true,
            section: 'details',
            readonly: true,
            position: 0,
            section: 'details',
            component: RadioListComponent,
            values: function (value) {
                return getPanelOptions([value]);
            },
        },
        name: {
            section: 'details',
            position: 1,
        },
        description: {
            section: 'details',
            position: 2,
            disabled: function (value, schema, data) {
                return data.local_page_id;
            },
        },

        link_value: {
            label: 'Link to Image 1',
            section: 'details',
            position: 3,
            component: UrlSelectComponent,
            link: ['/pages/_ref_', '/categories/_ref_', '/products/_ref_'],
        },

        image: {
            section: 'details',
            description: function(value, schema, data) {
                switch (data.panel_type) {
                    case 'banner-grid':
                    return 'Please resize banner images to 380px x 390px prior to uploading.'
                    break;
                }
            },
            position: 4,
            disabled: function (value, schema, data) {
                return ['banner-grid'].indexOf(data.panel_type) >= 0;
            },
        },




        link_value2: {
            label: 'Link to Image 2',
            section: 'details',
            position: 5,
            component: UrlSelectComponent,
            link: ['/pages/_ref_', '/categories/_ref_', '/products/_ref_'],
        },

        image2: {
            section: 'details',
            description: function(value, schema, data) {
                switch (data.panel_type) {
                    case 'banner-grid':
                    return 'Please resize banner images to 380px x 390px prior to uploading.'
                    break;
                }
            },
            position: 6,
            disabled: function (value, schema, data) {
                return ['banner-grid'].indexOf(data.panel_type) >= 0;
            },
        },

        link_value3: {
            label: 'Link to Image 3',
            section: 'details',
            position: 7,
            component: UrlSelectComponent,
            link: ['/pages/_ref_', '/categories/_ref_', '/products/_ref_'],
        },

        image3: {
            section: 'details',
            description: function(value, schema, data) {
                switch (data.panel_type) {
                    case 'banner-grid':
                    return 'Please resize banner images to 380px x 390px prior to uploading.'
                    break;
                }
            },
            position: 8,
            disabled: function (value, schema, data) {
                return ['banner-grid'].indexOf(data.panel_type) >= 0;
            },
        },

        link_value4: {
            label: 'Link to Image 4',
            section: 'details',
            position: 9,
            component: UrlSelectComponent,
            link: ['/pages/_ref_', '/categories/_ref_', '/products/_ref_'],
        },

        image4: {
            section: 'details',
            description: function(value, schema, data) {
                switch (data.panel_type) {
                    case 'banner-grid':
                    return 'Please resize banner images to 380px x 390px prior to uploading.'
                    break;
                }
            },
            position: 10,
            disabled: function (value, schema, data) {
                return ['banner-grid'].indexOf(data.panel_type) >= 0;
            },
        },


       
        content_id: {
            section: 'details',
            position: 4,
            disabled: function (value) {
                return !value;
            },
            component: {
                template: '<div role="success" class="alert alert-success"><img src="/img/icons/question-gr.svg" alt="Question"> {{ description }}</div>',
                props: ['description'],
            },
            description: 'This panel will use page images',
        }
    }
}



// WEBPACK FOOTER //
// ./resources/assets/cms/js/config/form.panel-project-list.js